import { mapGetters, mapState } from 'vuex'
import { result, map, groupBy } from 'lodash'

export default
{
	computed:
	{
		...mapState({ order: state => state.orders.order }),
		...mapGetters([ 'hasOrder' ]),

		isEligibleStatisticalOrder()
		{
			return this.checkStatisticalOrder(this.order)
		},
	},

	methods:
	{
		checkStatisticalOrder(order)
		{
			if ( this.checkAggBurstOrder(order) )
			{
				return false
			}

			return this.checkPortOrder(order)
				|| this.checkLagOrder(order)
				|| this.checkVlanOrder(order)
				|| this.checkMplsOrder(order)
				|| this.checkCloudOrder(order)
		},

		checkAggBurstOrder(order)
		{
			const { product_code } = order ?? {}

			product_code ??= ''

			return product_code?.includes('AGGREGATE_BURST')
		},

		checkMplsOrder(order)
		{
			const { product_code } = order ?? {}

			product_code ??= ''

			return product_code?.includes('_MPLS')
		},

		checkCloudOrder(order)
		{
			const { product_code } = order ?? {}

			product_code ??= ''

			return product_code?.includes('_CLOUD')
		},

		checkPortOrder(order)
		{
			const { port_interface } = order ?? {}

			return [ 13, 14, 33, 42, 45, 57 ].includes(port_interface)
		},

		checkLagOrder(order)
		{
			const { port_interface } = order ?? {}

			return [ 40 ].includes(port_interface)
		},

		checkVlanOrder(order)
		{
			const { port_interface } = order ?? {}

			return [ 15 ].includes(port_interface)
		},

		labelOrderSelectOption(order)
		{
			return [
				order.id,
				order.nua,
				order.product_code,
				result(order, 'ship_to.site_a.label'),
				result(order, 'ship_to.site_a.address'),
				(order.cancellation_date) ? ' - CANCELLED ' + order.cancellation_date.split(/T/).shift() : ''
			].filter(Boolean).join(' - ')
		},

		groupOrderSelectOptions(orders, grouping='category')
		{
			return map
			(
				groupBy
				(
					map
					(
						orders,
						order =>
						({
							...order,
							label: this.labelOrderSelectOption(order)
						})
					),
					grouping
				),
				(options,label) => ({ label, options })
			)
		},
	},
}